module.exports = __webpack_public_path__ + "static/media/slide-02.03520766.jpg";